import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {Cookies, withCookies} from 'react-cookie';
import {instanceOf} from 'prop-types';
//import Breadcrumbs from './components/Breadcrumb';
import Home from './components/Home/'
import {EventClient} from "./util/eventClient";
// Views
import Login from './views/Pages/Login/';
import Logout from './views/Pages/Logout/';
import Page404 from './views/Pages/Page404/';
import Page500 from './views/Pages/Page500/';
import Loading from './views/Pages/Loading/';
// Styles
// Import Flag Icons Set
// import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'
import SSO from "./views/Pages/SSO";
import {toast, ToastContainer} from "react-toastify";
import {clearGlobalState, getGlobalState, setGlobalState} from "./constants/GlobalStore";
import {BeforeOnload} from "./util/beforeOnload";
//import Header from './components/Header/';
//import Sidebar from './components/Sidebar/';
//import Aside from './components/Aside/';
//import Footer from './components/Footer/';

//localStorage.getItem('token')
class App extends Component {

  constructor(props) {
    super(props);
    const {cookies} = props;
    var _loginID = cookies.get('loginID') || 0;
    var _token = cookies.get('token') || "";
    var _expires = cookies.get('expiresAt') || 0;
    this._ssoRequest = cookies.get('SSO_REQUEST') || "";
    this.cookies = cookies;
    setGlobalState({
      loginID: _loginID,
      token: _token,
      expiresAt: _expires,
    });
    this.state = {
      loginID: _loginID,
      token: _token,
      expiresAt: _expires,
      lastActive: new Date(),
      perms: {},
      needsLoading: true,
      errorMsg: "",
    }
    this.errorAPIRender.bind(this);
  }

  componentWillMount() {
    BeforeOnload.init();
    EventClient.on('GLOBAL_ERROR', (data) => this.errorAPIRender(data), "GLOBAL_ERROR");
    EventClient.on('TOAST_SUCCESS', (data) => toast.success(data), "App");
    EventClient.on('TOAST_WARNING', (data) => toast.warn(data), "App");
    EventClient.on('TOAST_INFO', (data) => toast.info(data), "App");
    EventClient.on('TOAST_ERROR', (data) => toast.error(data), "App");
  }

  componentWillUnmount() {
    EventClient.off('GLOBAL_ERROR', (data) => this.errorAPIRender(data), "GLOBAL_ERROR");
    EventClient.off('TOAST_SUCCESS', (data) => toast.success(data), "App");
    EventClient.off('TOAST_WARNING', (data) => toast.warn(data), "App");
    EventClient.off('TOAST_INFO', (data) => toast.info(data), "App");
    EventClient.off('TOAST_ERROR', (data) => toast.error(data), "App");
    BeforeOnload.destroy();
  }

  isActive() {
    this.setState({lastActive: new Date()});
  }

  loginSuccess(id, token, expiresAt, perms, lmsMenu) {
    const {cookies} = this.props;
    var Dated = new Date(expiresAt * 1000);
    cookies.set('loginID', id, {path: '/', expires: Dated});
    cookies.set('token', token, {path: '/', expires: Dated});
    cookies.set('expiresAt', expiresAt, {path: '/', expires: Dated});
    setGlobalState({
      loginID: id,
      token: token,
      expiresAt: expiresAt,
      lastActive: new Date(),
      perms: perms,
      lmsMenu
    });
    this.setState({
      errorMsg: "",
      needsLoading: false,
      ...getGlobalState()
    });
  }

  reauthSuccess(id, token, expiresAt, perms, lmsMenu, callback = () => {
  }) {
    const {cookies} = this.props;
    setGlobalState({
      loginID: id,
      token: token,
      expiresAt: expiresAt,
      lastActive: new Date(),
      perms: perms,
      lmsMenu
    });
    this.setState({
      needsLoading: false,
      ...getGlobalState()
    });
    // var Dated = new Date(1);
    // cookies.set('SSO_REQUEST', "", {path: '/', expires: Dated, domain: ".afbn.us"});
    setTimeout(callback, 100);
  }

  reauthError(errorText, callback = () => {
  }) {
    const {cookies} = this.props;
    cookies.remove('loginID');
    cookies.remove('token');
    cookies.remove('expiresAt');
    setGlobalState({
      loginID: 0,
      token: "",
      expiresAt: 0,
      lastActive: new Date(),
      perms: {}
    });
    this.setState({
      needsLoading: false,
      ...getGlobalState(),
      errorMsg: errorText
    }, () => callback());
  }

  SSOSuccess(id, token, expiresAt, perms, lmsMenu, callback = () => {
  }) {
    const {cookies} = this.props;
    setGlobalState({
      loginID: id,
      token: token,
      expiresAt: expiresAt,
      lastActive: new Date(),
      perms: perms,
      lmsMenu
    });
    this.setState({
      needsLoading: false,
      ...getGlobalState()
    });
    var Dated = new Date(expiresAt * 1000);
    // cookies.set('SSO_REQUEST', "", { path: '/', expires:0, domain:".afbn.us"});
    cookies.set('loginID', id, {path: '/', expires: Dated});
    cookies.set('token', token, {path: '/', expires: Dated});
    cookies.set('expiresAt', expiresAt, {path: '/', expires: Dated});
    cookies.remove('SSO_REQUEST');
    setTimeout(callback, 100);
  }

  SSOError(errorText, callback = () => {
  }) {
    const {cookies} = this.props;
    cookies.remove('loginID');
    cookies.remove('token');
    cookies.remove('expiresAt');
    setGlobalState({
      loginID: 0,
      token: "",
      expiresAt: 0,
      lastActive: new Date(),
      perms: {}
    });
    this.setState({
      needsLoading: false,
      ...getGlobalState(),
      errorMsg: errorText
    });
    setTimeout(callback, 100);
  }

  SSOCross(token, expiresAt, callback = () => {
  }) {
    const {cookies} = this.props;
    var Dated = new Date(expiresAt * 1000);
    cookies.set('SSO_REQUEST', this.state.token, {path: '/', expires: Dated, domain: ".afbn.us"});
    setTimeout(callback, 100);
  }

  logoutSuccess() {
    const {cookies} = this.props;
    cookies.remove('loginID');
    cookies.remove('token');
    cookies.remove('expiresAt');
    clearGlobalState()
  }

  errorAPIRender(data) {
    console.log("error", data.response.status);
    if (data['response']['status'] === 401) {
      this.reauthError("Session Timed Out. Login Again.");
    } else {
      // Sentry.captureMessage(JSON.stringify(data));
      toast.error('AFBN API temporarily unavailable due to update. Please try your request again soon.');
    }
  }

  render() {
    const containerStyle = {
      zIndex: 1999
    };
    return (
      <div>
        {this.state.token != "" && this.state.loginID > 0 ?
          <BrowserRouter>
            <Switch>
              <Route exact
                     path="/sso/knvRhsfrg98srhktsBstry7ty98sdfiuhgg9eA589g89sghs49h8tg9h84Gt890e4783045sreotYeyst9889ys49y8eghoeshoghN4niogneg"
                     name="SSO" render={(props) => <SSO {...props} isAuthed={true} mainCtrl={this}
                                                        ssoRequest={this._ssoRequest}/>}/>
              <Route exact
                     path="/sso/knvRhsfrg98srhktsBstry7ty98sdfiuhgg9eA589g89sghs49h8tg9h84Gt890e4783045sreotYeyst9889ys49y8eghoeshoghN4niogneg/:refLink"
                     name="SSO" render={(props) => <SSO {...props} isAuthed={true} mainCtrl={this}
                                                        ssoRequest={this._ssoRequest}
                                                        refLink={props.match.params.refLink}/>}/>
              <Route exact
                     path="/sso/A45nbkF9DlskZjkdjgJkfmdmTnmtnjDFk98ojiFo4t9u8joiOJIGIJOGreoi345otjis98s34rtoKLFGkleostjWhisgGRIURtgisaeo"
                     name="SSO" render={(props) => <SSO {...props} isAuthed={true} mainCtrl={this}
                                                        redirectTo={"https://portal.afbn.us/sso.php?redirect=A45nbkF9DlskZjkdjgJkfmdmTnmtnjDFk98ojiFo4t9u8joiOJIGIJOGreoi345otjis98s34rtoKLFGkleostjWhisgGRIURtgisaeo"}/>}/>
              <Route exact
                     path="/sso/A45nbkF9DlskZjkdjgJkfmdmTnmtnjDFk98ojiFo4t9u8joiOJIGIJOGreoi345otjis98s34rtoKLFGkleostjWhisgGRIURtgisaeo/:refLink"
                     name="SSO" render={(props) => <SSO {...props} isAuthed={true} mainCtrl={this}
                                                        redirectTo={"https://portal.afbn.us/sso.php?redirect=A45nbkF9DlskZjkdjgJkfmdmTnmtnjDFk98ojiFo4t9u8joiOJIGIJOGreoi345otjis98s34rtoKLFGkleostjWhisgGRIURtgisaeo&ref=" + props.match.params.refLink}/>}/>
              <Route exact path="/logout" name="Logout"
                     render={(props) => <Logout {...props} isAuthed={true} mainCtrl={this}/>}/>
              <Route exact path="/404" name="Page 404" component={Page404}/>
              <Route exact path="/500" name="Page 500" component={Page500}/>
              <Route exact path="/loading" name="Loading"
                     render={(props) => <Loading {...props} isAuthed={true} mainCtrl={this}/>}/>
              {this.state.needsLoading ?
                <Route path="/" name="Loading"
                       render={(props) => <Loading {...props} isAuthed={true} mainCtrl={this}/>}/>
                :
                <Route path="/" name="Home"
                       render={(props) => <Home {...props} token={this.state.token}
                                                perms={getGlobalState("perms") || this.state.perms}
                                                isAuthed={true} mainCtrl={this}
                                                loginID={getGlobalState("loginID") || this.state.loginID}/>}/>
              }
            </Switch>
          </BrowserRouter>
          :
          <BrowserRouter>
            <Switch>
              <Route exact
                     path="/sso/knvRhsfrg98srhktsBstry7ty98sdfiuhgg9eA589g89sghs49h8tg9h84Gt890e4783045sreotYeyst9889ys49y8eghoeshoghN4niogneg"
                     name="SSO" render={(props) => <SSO {...props} isAuthed={true} mainCtrl={this}
                                                        ssoRequest={this._ssoRequest}/>}/>
              <Route exact
                     path="/sso/knvRhsfrg98srhktsBstry7ty98sdfiuhgg9eA589g89sghs49h8tg9h84Gt890e4783045sreotYeyst9889ys49y8eghoeshoghN4niogneg/:refLink"
                     name="SSO" render={(props) => <SSO {...props} isAuthed={true} mainCtrl={this}
                                                        ssoRequest={this._ssoRequest}
                                                        refLink={props.match.params.refLink}/>}/>
              <Route exact path="/login" name="Login Page"
                     render={(props) => <Login {...props} errorMsg={this.state.errorMsg} isAuthed={true}
                                               mainCtrl={this}/>}/>
              {/*<Route exact path="/forgot" name="Forgot Page" render={(props) => <Forgot {...props} isAuthed={true} mainCtrl={this} />}/>*/}
              <Route path="/" name="Login Page"
                     render={(props) => <Login {...props} errorMsg={this.state.errorMsg} isAuthed={true}
                                               mainCtrl={this}/>}/>
            </Switch>
          </BrowserRouter>
        }
        <ToastContainer position="top-right" autoClose={5000} style={containerStyle}/>
      </div>
    );
  }
}

App.propTypes = {
  cookies: instanceOf(Cookies).isRequired
}
export default withCookies(App);


// WEBPACK FOOTER //
// ./src/App.js